export const DateFilterIcon = ({ color = 'currentColor', ...props }: JSX.IntrinsicElements['svg']) => {
  return (
    <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        opacity='0.15'
        d='M0.75 5.25C0.75 3.59315 2.09315 2.25 3.75 2.25H12.75C14.4069 2.25 15.75 3.59315 15.75 5.25V6H0.75V5.25Z'
        fill={color}
      />
      <path
        d='M14.75 7.75H9.25C8.69772 7.75 8.25 8.19772 8.25 8.75V9.47842C8.25 9.73316 8.34721 9.97829 8.5218 10.1638L10.4782 12.2425C10.6528 12.428 10.75 12.6731 10.75 12.9278V15.1688C10.75 15.595 11.2491 15.8258 11.5738 15.5497L12.8976 14.4245C13.1212 14.2345 13.25 13.9559 13.25 13.6626V12.9278C13.25 12.6731 13.3472 12.428 13.5218 12.2425L15.4782 10.1638C15.6528 9.97829 15.75 9.73316 15.75 9.47842V8.75C15.75 8.19772 15.3023 7.75 14.75 7.75Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path
        d='M11.25 0C11.6642 0 12 0.335786 12 0.75V1.5H12.75C14.8211 1.5 16.5 3.17893 16.5 5.25V6.61621C16.0849 6.27349 15.567 6.0521 15 6.00098V5.25C15 4.00736 13.9926 3 12.75 3H12V3.75C12 4.16421 11.6642 4.5 11.25 4.5C10.8358 4.5 10.5 4.16421 10.5 3.75V3H6V3.75C6 4.16421 5.66421 4.5 5.25 4.5C4.83579 4.5 4.5 4.16421 4.5 3.75V3H3.75C2.50736 3 1.5 4.00736 1.5 5.25V12.75C1.5 13.9926 2.50736 15 3.75 15H9V15.1689C9.00006 15.686 9.16447 16.1383 9.43164 16.5H3.75C1.67893 16.5 0 14.8211 0 12.75V5.25C1.28851e-07 3.17893 1.67893 1.5 3.75 1.5H4.5V0.75C4.5 0.335786 4.83579 0 5.25 0C5.66421 0 6 0.335786 6 0.75V1.5H10.5V0.75C10.5 0.335786 10.8358 0 11.25 0Z'
        fill={color}
      />
    </svg>
  );
};
